var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"word-document",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }